<template>
  <b-navbar-nav class="flex-row ml-auto">
    <b-nav-item-dropdown
      v-if="$store.getters['auth/isAuthenticated']"
      right
      no-caret
      menu-class="position-absolute p-1"
      toggle-class="my-auto btn"
      class="w-100 dropdown-menu-lg pb-0"
    >
      <template #button-content>
<!--        <img src="/img/profile_icon.svg">-->
         <AppSvgIcon class="font-size-lg" :icon="$getConst.svgIcons.profile" height="35" :tooltip="$t($getConst.pages.settings.profile) | capitalize"/>

      </template>

      <div class="bg-composed-wrapper bg-gradient-primary">
        <div class="bg-composed-wrapper--image bg-composed-img-5"></div>
        <div class="bg-composed-wrapper--content text-light text-left py-3 px-3">
          <h6 class="mb-1 text-capitalize">{{this.$store.getters["auth/fullName"]}}</h6>
          <p class="mb-0 opacity-7">{{this.$store.getters["auth/userEmail"]}}</p>
          <span v-if="$store.getters['auth/connectedRole']">
            {{ $t($getConst.pages.permission.connected_as) }} {{ $store.getters['auth/connectedRole'] }}
          </span>
        </div>
      </div>

      <div class="list-group list-group-flush">

        <b-dropdown-item @click="goProfileDetails" link-class="list-group-item list-group-item-action align-box-row">
          <AppSvgIcon class="font-size-lg mr-3" :icon="$getConst.svgIcons.personal_details" height="30" :tooltip="$t($getConst.pages.settings.profile) | capitalize"/>
          <div>
            {{$t($getConst.pages.settings.profile) | capitalize}}
          </div>
        </b-dropdown-item>

        <b-dropdown-item @click="goChangeEmail" link-class="list-group-item list-group-item-action align-box-row">
          <AppSvgIcon class="font-size-lg mr-3" :icon="$getConst.svgIcons.SECURITY_ICON_BLUE" height="30" :tooltip="$t($getConst.pages.settings.edit_email) | capitalize"/>
          <div>
            {{$t($getConst.pages.settings.edit_email) | capitalize}}
          </div>
        </b-dropdown-item>

        <b-dropdown-item @click="goChangePassword" link-class="list-group-item list-group-item-action align-box-row" :disabled="$store.getters['auth/isLoggedAs']">
          <AppSvgIcon class="font-size-lg mr-3" :icon="$getConst.svgIcons.user_password" height="30" :tooltip="$t($getConst.pages.settings.change_password) | capitalize"/>
          <div>
            {{$t($getConst.pages.settings.change_password) | capitalize}}
          </div>
        </b-dropdown-item>

        <b-dropdown-item v-if="$store.getters['auth/userHasMultiRole']" @click="selectRole" link-class="list-group-item list-group-item-action align-box-row">
          <AppSvgIcon class="font-size-lg mr-3 pl-1" :icon="$getConst.svgIcons.selectRole" height="25" :tooltip="$t($getConst.pages.permission.change_role) | capitalize"/>
          <div>
            {{$t($getConst.pages.permission.change_role) | capitalize}}
          </div>
        </b-dropdown-item>

        <b-dropdown-item @click="logout" link-class="list-group-item list-group-item-action align-box-row" :disabled="$store.getters['auth/isLoggedAs']">
          <AppSvgIcon class="font-size-lg mr-3 pl-1" :icon="$getConst.svgIcons.signOut" height="25" :tooltip="$t($getConst.pages.settings.sign_out) | capitalize"/>
          <div>
            {{$t($getConst.pages.settings.sign_out) | capitalize}}
          </div>
        </b-dropdown-item>
      </div>
    </b-nav-item-dropdown>
    <template v-else>
      <LanguagesMultiselect></LanguagesMultiselect>
      <b-nav-item
        link-classes="font-weight-bold font-size-lg text-capitalize text-nowrap"
        @click="login">
        {{$t($getConst.pages.settings.sign_in)}}
      </b-nav-item>
    </template>
  </b-navbar-nav>












</template>

<script>
  import routesNames from "../../../shared/constants/router";
  import {changePassword} from "../../../shared/services/ad_b2c/authRedirect";
  import {logSignOut} from "../../../api/user.api";
  import LanguagesMultiselect from "../../common/Languages/LanguagesMultiselect";
  export default {
    name: "ProfileDropdown",
    components: {LanguagesMultiselect},
    methods: {
      logout() {
        this.$store.dispatch('loader/show');
        logSignOut().then(res => {
            this.$store.dispatch("auth/logout");
          },
          error => {
            this.$store.dispatch('loader/hide');
          }
        );
      },
      login() {
        this.$store.dispatch('auth/signIn', window.location.origin)
      },
      goProfileDetails() {
        this.$router.push({name: routesNames.profile.details});
      },
      goChangePassword() {
        changePassword();
      },
      goChangeEmail() {
        this.$router.push({name: routesNames.profile.email});
      },
      selectRole() {
        this.$router.push({name: routesNames.selectRole});
      },
    }
  }
</script>

<style scoped>

</style>
